import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core';
import { green, grey, blue } from '@material-ui/core/colors';
import Chip from '@material-ui/core/Chip';

import { RATING_CHIP_LABELS } from '../utils/const';

const RatingStatusChip = ({ ratingStatus }) => {
  const { t } = useTranslation();

  const useStyles = makeStyles({
    notAvailable: {
      background: grey[200]
    },
    inProgress: {
      background: blue[200]
    },
    completed: {
      background: green['A100']
    }
  });

  const classes = useStyles();

  return (
    <Chip
      label={ t(RATING_CHIP_LABELS[ratingStatus]) }
      className={ classes[ratingStatus] }
    />
  );
};

export default RatingStatusChip;
